import { render, staticRenderFns } from "./page copy.vue?vue&type=template&id=b4e1f8ba&scoped=true&"
import script from "./page copy.vue?vue&type=script&lang=js&"
export * from "./page copy.vue?vue&type=script&lang=js&"
import style0 from "./page copy.vue?vue&type=style&index=0&id=b4e1f8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e1f8ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4e1f8ba')) {
      api.createRecord('b4e1f8ba', component.options)
    } else {
      api.reload('b4e1f8ba', component.options)
    }
    module.hot.accept("./page copy.vue?vue&type=template&id=b4e1f8ba&scoped=true&", function () {
      api.rerender('b4e1f8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/page copy.vue"
export default component.exports